import React from 'react';
import classNames from 'classnames';

function SocialIconAuth({
  socialIconImage,
  handleSocialLogin,
  socialIconLabel,
  additionalClassName,
}) {
  return (
    <span
      role="button"
      style={{ display: 'inline-block', marginBottom: '3px' }}
      tabIndex="0"
      onClick={() => handleSocialLogin(socialIconLabel)}
      onKeyDown={() => handleSocialLogin(socialIconLabel)}
    >
      {/* <img
        className={classNames([additionalClassName])}
        alt={`Log in with ${socialIconLabel}.`}
        src={socialIconImage}
      /> */}
      <picture>
        <source
          media="(max-width: 799px)"
          srcSet={socialIconImage}
          width="480"
          height="400"
        />
        <source
          media="(min-width: 800px)"
          srcSet={socialIconImage}
          width="800"
          height="400"
        />
        <img
          className={classNames([additionalClassName])}
          alt={`Log in with ${socialIconLabel}.`}
          src={socialIconImage}
          width="800"
          height="400"
        />
      </picture>
    </span>
  );
}

export default SocialIconAuth;
